/** Retail sale request schema (plan 05). Money is integer minor units. */
import { z } from 'zod';

export const RetailSaleItemSchema = z.object({
  product_id: z.string().uuid(),
  name: z.string().min(1),
  quantity: z.number().positive(),
  unit_price: z.number().int().nonnegative(),
  tax_rate_code: z.enum(['A', 'B', 'C', 'EXEMPT']),
  total: z.number().int().nonnegative(),
});

export const RecordRetailSaleRequestSchema = z.object({
  tenant_id: z.string().uuid(),
  location_id: z.string().uuid(),
  member_id: z.string().uuid().nullable().optional(),
  items: z.array(RetailSaleItemSchema).min(1),
  tenders: z
    .array(
      z.object({
        method: z.enum(['cash', 'card', 'bank_transfer', 'voucher', 'gift_card', 'online']),
        amount: z.number().int().positive(),
      }),
    )
    .min(1),
  recorded_by_staff_id: z.string().uuid(),
  issued_at: z.string().datetime(),
  client_event_id: z.string().uuid().optional(),
  fiscal_device_id: z.string().uuid().optional(),
  fiscalize: z.boolean().default(true),
});

export type RecordRetailSaleRequest = z.infer<typeof RecordRetailSaleRequestSchema>;
